// Module
var code = "<div class=pureSelectLabel><%= text %></div>";
// Exports
module.exports = code;